const links = [
  {
    id: "link_#0",
    link: "http://deccoapproved.arborwear.com/",
    name: "Arborwear",
    description: "Online DECCO Store",
  },
  {
    id: "link_#1",
    link: "https://decco.myabsorb.com/#/login",
    name: "DECCO U",
    description: "DECCO U Access",
  },
  {
    id: "link_#2",
    link: "https://www.myworkday.com/comfortsystemsusa/learning",
    name: "Workday",
    description: "Workday Learning",
  },
];

export default links;
